export default "__VITE_ASSET__C0IXg5OA__"